import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesListForm {
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    if (webcontext.Client.PageName == "ListForm") {
      if (webcontext.SpecialParameter === "scanner") {
        const scanner = webcontext.RequestBody.scanner;//"金立3|130da955-43a9-4880-b691-6734d4597406";
        const datas = this.getDataArrayList(scanner, webcontext);
        webcontext = datas;
        if (webcontext.RequestBody.orderdata.totalCount <= 0)
         {
          webcontext.ResponseMessage.Success = false;
          webcontext.ResponseMessage.ErrorMessage = "条形码不存在";
        }
      }
      if (webcontext.ConfigName == "TBXiaDingDanXML" && webcontext.OpType.toLowerCase() == "add") {
        webcontext.ConfigName = "OrderMasterXML";//"TBJingZhiYouJiXML";
        // webcontext = this.addOrderMasterData(webcontext);
        // console.log(webcontext.RequestBody);
        // webcontext.ResponseMessage.Success = false;
        // webcontext.ResponseMessage.ErrorMessage = "暂停提交";
      }
      //下订单
      if (webcontext.OpType.toLowerCase() == "query") {
        webcontext.ConfigName = "TBOrderXML";//"TBUPDateXiaDingDanXML";//"TBJingZhiYouJiXML";
        // webcontext = this.addOrderMasterData(webcontext);
        // console.log(webcontext.RequestBody);
        // webcontext.ResponseMessage.Success = false;
        // webcontext.ResponseMessage.ErrorMessage = "暂停提交";
      }

      //编辑订单
      if (webcontext.OpType.toLowerCase() == "edite") {
        webcontext.ConfigName = "PlaceOrder";//"TBJingZhiYouJiXML";
        const id = JSON.parse(webcontext.RequestBody).a_ID;
        webcontext.RequestBody = JSON.stringify({ 'OredID': id });
      }
    }
    return this.addOrderMasterData(webcontext);
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
   const that = this;
    if(webContext.ResponseMessage.Success){
    //   if(webParameterContext.OpType.toLocaleLowerCase()=="add"){
    //     webContext.Status = {"ignore":true};
    //   }
      if(webParameterContext.OpType.toLocaleLowerCase()=="edite"){
        webContext = this.getEditeData(webContext);
      }
   }
    return webContext
  }
  /**
   * 
   * @param webcontext 添加订单数据组装
   */
  private addOrderMasterData(webcontext: WebParameterContext): WebParameterContext {
    let masterOrder = {};
    let arrayData: Array<any> = JSON.parse(webcontext.RequestBody);
    arrayData.forEach((items, index) => {
      delete arrayData[index].a_XiaoLiangHeJi;
      delete arrayData[index].a_ZiRanXiaoLiang;
      delete arrayData[index].a_BuHuoLiang;
      delete arrayData[index].a_XiaoLiang;
    });
    if (webcontext.SpecialParameter) {
      if (webcontext.SpecialParameter.Data.length > 0) {
        masterOrder["a_totalMoney"] = webcontext.SpecialParameter.totalMoney;
        masterOrder["a_Number"] = webcontext.SpecialParameter.totalCount;
        masterOrder["a_num"] = webcontext.SpecialParameter.Data.length;
        masterOrder["a_OrderNum"] = "NP" + Math.floor(Math.random() * 1000000000000);
        masterOrder["a_FK_TBCeShiXinKeLieBiao_ID"] = webcontext.ID;
        masterOrder["CHILDOBJ_TBJingZhiYouJiXML"] = {
          "Datas": arrayData,
          "Info": {
            "FormFKElementModel": "a_FK_OrderMaster_ID",
            "ProviderFKElementModel": "a_ID",
            "FormConfigName": "TBJingZhiYouJiXML"
          }
        };
      }
    }
    webcontext.RequestBody = JSON.stringify(masterOrder);
    return webcontext;
  }
  private getDataArrayList(scanner: string, webcontext: WebParameterContext): WebParameterContext {
    let data = {};
    let arrayData: Array<any> = webcontext.RequestBody.data;
    const groupName = scanner.split('|')[0];
    const item_ID = scanner.split('|')[1];
    if (arrayData.length > 0) {
      arrayData.forEach((gitem, index) => {
        if (gitem.GroupName === groupName) {
          gitem.items.forEach((item, indexs) => {
            if (item.a_ID === item_ID) {
              arrayData[index].isOpen = true;
              let num: number = Number(arrayData[index].items[indexs].a_xiadanliang) + 1;
              arrayData[index].items[indexs].a_xiadanliang = num;
              arrayData[index].items[indexs].a_zongjia = num * Number(arrayData[index].items[indexs].a_danjia);
            }
          })
        } else {
          arrayData[index].isOpen = false;
        }
      });
    }
    webcontext.RequestBody.data = arrayData;
    webcontext.RequestBody["orderdata"] = this.getDataOrderArray(arrayData);

    return webcontext;
  }
  /**
   * 
   * @param orderList 计算下单量
   */
  private getDataOrderArray(orderList: Array<any>): Array<any> {
    let orederData: any = {
      totalCount: 0,
      totalMoney: 0,
      Data: new Array<any>()
    };
    let xiadanliang: number = 0;
    let totalMoney: number = 0;
    orderList.forEach((group, index) => {
      group.items.forEach((items, indexs) => {
        if (Number(items.a_xiadanliang) > 0) {//下单量大于零
          orederData.Data.push(items);
          if (xiadanliang <= 0) {
            xiadanliang += Number(items.a_xiadanliang);
          } else {
            xiadanliang += 1;
          }

          totalMoney += Number(items.a_zongjia || 0);
        }
      });
    });
    orederData.totalCount = xiadanliang;
    orederData.totalMoney = totalMoney;
    return orederData;
  }


  public ContextBeforeChangeValue(webcontext: any, ConfigName: string): any {
    if (ConfigName == "ListForm") {
      webcontext.isPlacingOrder = true;
      if(webcontext.a_xiadanliang > 0){
        if (parseInt(webcontext.a_xiadanliang) > parseInt(webcontext.a_kucun)) {
          webcontext.a_xiadanliang = parseInt(webcontext.a_kucun);
        }
        webcontext.a_zongjia = webcontext.a_danjia * webcontext.a_xiadanliang;
      }
    }
    return webcontext;
  }

  /**
   * 处理编辑时数据
   * @param data 添加订单数据组装
   */
  private getEditeData(webContext){
    return webContext;
    webContext.Status = {
      "Datas": [
          {
              "a_ID": "70fd2734-4698-4b96-adf7-06453744a631",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体3段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 5,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "9f191d61-d360-4636-b024-0960b0da6e3a",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护3段听820配方奶粉",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 5,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "bb29baa7-0d30-4287-b70d-143ff72a7a68",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护2.0版3段820低乳糖",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 5,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "72cd73e0-4579-4b5a-8e28-156dad06877b",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体 S3 900g整箱装-单听",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "59c32efe-4e8d-4463-a5a9-1784027e3bdf",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净4段900g(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 2,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "e907b1a0-0412-4148-a8a8-1b1769145fa8",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机RRR1段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 5,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "50497e86-abfd-48ec-a802-1b35b80eec79",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机3段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": -2,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "89b0586f-9bd8-424d-ae69-1c2ee19e54a0",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护1段听360配方奶粉",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "53d9bfb1-21dd-4f21-8915-1c334833ad58",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护2.0版1段820低乳糖",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "26b7572a-936c-433b-bfbd-1c7b660d884b",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体2段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "eb32f4ad-23ab-458c-b9a8-209f0a2e4381",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净2段900g(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "b6b08ada-8101-4324-b765-21b0b6094fe4",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机RRR3段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "bd002de6-3bfb-4544-a10f-25c7b12f64df",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体2段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "f2d5dfb4-916b-4a4d-a2f1-27063db59b01",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体1段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2694c37b-3c73-433f-a8e5-27633dc77c47",
              "a_GroupingName": "小安素",
              "a_title": "金小安素草莓味BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "506e03a0-5a3c-42df-8800-2a0a30ab1881",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净1段900g(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "cbfe87ed-ba51-4c47-a4cd-2f891e00a5ea",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体4段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "0d18c9db-6229-4847-84a3-339fcf68ca49",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护3段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "7272d1da-e845-4620-9d39-3750183f22c2",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护1段听360",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ad102f97-1a6b-4802-bfbe-38dd514ec058",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护2段听820",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ab4c767a-be4a-4df8-be0c-406a7cbec62e",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体铂金版3段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2da3a3d8-17f3-444d-b4ba-43f380b7c8fd",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护1段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "97068ec4-4951-45d9-835c-442b2b432a0a",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体4段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "a47087a2-3bfa-4a77-b231-520f4ae67bf2",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护3段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "bacc465b-0d8b-4d1a-a4ad-53c3ffe7d0c9",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护4段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "f139e699-e69a-4ceb-9640-5fb27ea61d09",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护3段听820",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "bf720510-acd0-4626-98a3-627261b05669",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体1段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "5fc7dac4-0e58-4f93-8995-711558f5d252",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机1段（新罐）听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "d7acf6b1-2699-46a8-af87-77789c1e7022",
              "a_GroupingName": null,
              "a_title": null,
              "a_danjia": 0,
              "a_zongjia": 0,
              "a_IsDelete": true,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 18:58:16",
              "a_kucun": 0,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "5c06d314-ae8b-49b6-9d89-77a88bb0c78e",
              "a_GroupingName": "雅培恩美力",
              "a_title": "雅培亲护3段820g低乳糖(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "952102a6-ad02-403c-98e8-7e601ea7814c",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净3段900g(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "0f6bf8c2-38b5-486c-a67c-7fa80989f606",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净1段400g(NFSL)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "96ea3e28-8bcf-48d1-8958-7fbba0c7e260",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体3段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2b954963-a0b8-4085-a957-86646f82fecb",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机1段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "a7171138-f45b-4710-b5d0-874e27bb1a43",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护1段听820",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "13428853-a6c9-4634-bd7f-8ad9e10a43f0",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护1段听360(低乳糖配方)",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "7485eb39-404e-40db-98fc-8b4d7a9a6932",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机2段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "01ce61c1-ccbf-4ee6-b7aa-8e1f7d5ca91f",
              "a_GroupingName": "小安素",
              "a_title": "金小安素香草味BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "d7185737-d299-4ced-a0aa-8ee55174dc9c",
              "a_GroupingName": "小安素",
              "a_title": "金小安素香草味听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2970d67b-ac2f-4a28-988e-954e8d06ed2f",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机RRR3段听900*6整箱装-单听",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2f3f1f9b-1ed4-49ae-b7d5-9ba51374c42d",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护3段听820",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "26a40b29-4368-42a5-8f8c-a0e2ec58d8c8",
              "a_GroupingName": null,
              "a_title": null,
              "a_danjia": 0,
              "a_zongjia": 0,
              "a_IsDelete": true,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 18:59:37",
              "a_kucun": 0,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "6b1186ce-1e71-421f-9692-a26441f47a12",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机RRR1段听400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "1ef6fb98-0d80-43ec-96e6-a27cb6c903e5",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体3段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ab63f0ff-7ed7-400b-922a-ae50f79f4188",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体铂金版2段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "dc27c029-6390-4c52-abe0-afe8dfbbbac5",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体1段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "48e05470-985a-4b36-8f75-b0be77f1e09b",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护2.0版2段820低乳糖",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ca0b8741-629e-4d1d-a6be-b41f96013c12",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体铂金版4段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "c91e2b9d-bf47-4008-9e1e-be2d8809f067",
              "a_GroupingName": "菁挚",
              "a_title": "雅培菁挚纯净3段900g*6整箱装(NFSL)-单听",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "8fef062e-dc42-4ad3-96e6-bf2600630d8b",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机1段听400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "188e2b2c-8c59-4fb7-855e-c03734102ee6",
              "a_GroupingName": "小安素",
              "a_title": "金小安素天然草莓味900克",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "c03768cb-a5ce-4bd5-9a27-c331742c6146",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体2段BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "4c0ffa50-f44c-4d81-8b3e-c5df41322cf4",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机RRR2段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "8b99057d-0bf8-481b-bf61-c7a0557937a6",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体1段BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "67759530-467e-4f90-9316-d0091e9634c0",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护4段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "4b89adeb-5f46-4046-8057-d0cebb3b7163",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体1段听400g",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "2933727f-771a-448d-b5a6-d3ee9f70b619",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体双重倍护2段智锁罐900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "d91c56d6-62ef-45a8-ba55-d60739a63f61",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机2段（新罐）听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "92a2e397-b4af-4c30-abe9-d9511437f05e",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护2段听820配方奶粉",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "55d0bb0d-b987-40a8-ba63-db6b32e8c714",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体3段BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "88f57d81-de3b-48eb-8a92-ddaeab587800",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体2段BIB400三联包",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "7fb84d7b-a873-4ef5-8462-e6ef1a6f97f5",
              "a_GroupingName": "雅培恩美力",
              "a_title": "新亲护1段听820配方奶粉",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "cec87706-9fdf-4358-a75e-eb089d4ed96d",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲体4段BIB400",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ba2333b0-ca78-469f-9236-f2dbdfea42c1",
              "a_GroupingName": "菁挚",
              "a_title": "菁智有机3段（新罐）听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2019-01-07 17:20:34",
              "a_kucun": -9,
              "a_xiadanliang": 8,
              "a_Fk_OrderMaster_ID": "69f324d9-de03-4a15-b6ff-50153c80ce90",
              "a_FK_TBCeShiXinKeLieBiao_ID": "3da123c5-4b24-4696-95ee-55166d03d8f3"
          },
          {
              "a_ID": "975148c4-b705-4312-a6d6-fb2f98ced36c",
              "a_GroupingName": "雅培恩美力",
              "a_title": "亲护2.0版1段360低乳糖",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "ffd2d473-91b6-4aee-bcb0-fdbf0f07f34b",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体铂金版1段听900",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          },
          {
              "a_ID": "6fee9456-6f13-4236-bdde-fe0d38b5ccea",
              "a_GroupingName": "雅培恩美力",
              "a_title": "欧版亲体铂金版1段听400g",
              "a_danjia": 15,
              "a_zongjia": 0,
              "a_IsDelete": false,
              "a_IsValid": true,
              "a_ModifyTime": "2018-12-28 14:09:37",
              "a_kucun": 8,
              "a_xiadanliang": 0,
              "a_Fk_OrderMaster_ID": null,
              "a_FK_TBCeShiXinKeLieBiao_ID": null
          }
      ],
          "RecordCount": 67
  }
    return webContext;
  }

}